function switchTab() {
  // 各ブランドタブグループごとの処理
  const brandTabGroups = document.querySelectorAll(".hb-brand .hb-js-brandSelectBtn");
  const brandCollections = document.querySelectorAll(".hb-brand .hb-js-brandVisibleList > li");

  brandTabGroups.forEach((group) => {
    const tabs = group.querySelectorAll("li");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        // 同じグループ内のタブのみadd-activeを制御
        tabs.forEach((t) => t.classList.remove("add-active"));
        tab.classList.add("add-active");

        // コレクションの表示制御
        brandCollections.forEach((c) => c.classList.remove("add-active"));
        if (brandCollections[index]) {
          brandCollections[index].classList.add("add-active");
        }
      });
    });
  });
}

function getBrandName() {
  const pathname = window.location.pathname;
  const brandName = pathname.match(/(?<=\/collections\/)[^/?]+/)?.[0] || '';
  return brandName
}

function getBrandSelectBtn() {
  const brandSelectBtns = document.querySelectorAll('.hb-js-brandSelectBtn .hb-brand_item');
  const selectBtnsName = [...brandSelectBtns].map(btn => btn.innerText.toLowerCase().replace(' ', '-').replace(/\n/, ''));
  return {
    brandSelectBtns,
    selectBtnsName
  }
}

function changeActiveTab(brandName) {
  const { brandSelectBtns, selectBtnsName } = getBrandSelectBtn();
  const brandContents = document.querySelectorAll('.hb-js-brandVisibleList .hb-brand_collectionItem');
  
  if (selectBtnsName.includes(brandName) === false) return;

  selectBtnsName.forEach((btnName, index) => {
    if (btnName === brandName) {
      brandSelectBtns[index].classList.add('add-active');
      brandContents[index].classList.add('add-active');
    } else {
      brandSelectBtns[index].classList.remove('add-active');
      brandContents[index].classList.remove('add-active');
    }
  });
}

function setLocalStorageBrandName(e) {
  let key = 'brandName';
  let brandName = e.target.dataset.brand;
  window.localStorage.setItem(key, brandName);
}

function getLocalStorageBrandName() {
  let key = 'brandName';
  return window.localStorage.getItem(key);
}

function removeLocalStorageBrandName() {
  window.localStorage.removeItem('brandName');
}

function initActiveTab(brandName) {
  if (!brandName) {
    // navのブランドを選択した場合
    const brandName = getBrandName();
    changeActiveTab(brandName);
  } else {
    // 「ブランド一覧から探す」のキャラクターを選択した場合
    changeActiveTab(brandName);
  }
}

(function execute() {
  // タブを切り替える
  switchTab();

  // コレクションに遷移した際、一致するブランドタブをアクティブ化させるためのデータ
  const characterIcons = document.querySelectorAll('.hb-js-brand_figItem');
  characterIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      setLocalStorageBrandName(e);
    });
  });

  if (document.body.classList.contains("template-collection")) {
    const brandName = getLocalStorageBrandName();
    initActiveTab(brandName);
    removeLocalStorageBrandName();
  }
})();